<template>
  <div id="app">
    <transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
  </div>
</template>

<script>
import store from "./utils/storage";

export default {
  name: "App",
  mounted() {
   
  }
};
</script>

<style>
@import "./assets/css/base.css";
</style>



// WEBPACK FOOTER //
// src/App.vue